define([
	"dojo/_base/declare",
	"csi",
	"csi/xml",
	"csi/xml/Query",
	"Specification/ResponseItemsTable"
], function(declare,csi,xml,Query,ResponseItemsTable) {

	return declare(ResponseItemsTable, {
		selectedResponse: csi.EMPTY_URL,

		/**
		 * @override
		 * Add filter to get the results fromlatest rev of the selected supplier response.
		 */
		_createQueryLevel: function(params, bRoot) {
			var ql = this.inherited(arguments);

			if (ql.bMain && xml.isValidURL(this.selectedResponse)) {
				const responseNode = this.getViewNode();
				const latestResponseRev = responseNode && responseNode.LatestRevision;
				ql.serverQuery = new Query()
								.RefAttr("__Parent__", xml.OP_EQUALS, this.selectedResponse,  "Child:__Parent__")
								.RefAttr("__Parent__", xml.OP_EQUALS, latestResponseRev);
			}
			return ql;
		}
	});
});